import { useEffect, useState } from "react";
import { CustomError } from "../http/errors";

const useDataInitializer = <T>(data?: T, error?: CustomError): [T | undefined, CustomError | undefined, boolean] => {
  const [isInitialized, setIsInitialized] = useState<boolean>(!!data);
  const [state, setState] = useState<T | undefined>(data);

  useEffect(() => {
    (data || error) && !isInitialized && setIsInitialized(true);
    setState(!error ? data : undefined);
  }, [data, error]);

  return [state, error, isInitialized];
};

export default useDataInitializer;
